import { Options, Vue } from 'vue-class-component';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { RouteN } from '@/constants/route-name'
import store from '@/store';
import { AuthorizedUser } from '@/models/authorized-user';
import { AuthenticationStatusType } from '@/modules/authentication/authentication-status';
import StdPageLayout from '@/components/std-page-layout/index.vue';
import { IDLESessionManager } from '@/modules/session/idle-session-manager';

Vue.registerHooks(['beforeRouteEnter']);
@Options({
  components: {
    StdPageLayout
  }
})
export default class CMPMain extends Vue {

  private idleSessionMgr: IDLESessionManager = new IDLESessionManager();

  beforeRouteEnter (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    const c1: boolean = to.matched.some((record) => record.meta.requiresAuth);
    const c2: boolean = (store.getters.getUserAccount as AuthorizedUser)
      .authenticationStatus === AuthenticationStatusType.AppAccessPermitted;
    
    if (c1 && !c2) {
          
      next({ name: RouteN.CMP.LoginPage.n, query: { redirect: to.fullPath } });

    } else {

      next();

    }
    
  }

  created() {
    this.idleSessionMgr.run(this.idleSessionTimeoutCallback);
  }

  public idleSessionTimeoutCallback(): void {
    this.$router.push({ name: RouteN.CMP.LogoutPage.n });
  }

  beforeUnmount() {
    this.idleSessionMgr.stop();
  }
}


